<template>
  <div class="box">
    <div class="top_box">
      <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click.stop="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click.stop="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
      <div class="fle_t ali_ct w100">
        <img src="@/assets/img/upload_logo.png" class="top_txt fle_no" alt>
        <img src="@/assets/img/form_warn.png" class="box_warn fle_no" alt>
        <div class="diy_input dis_f ali_ct jus_bt" @click.stop="changeShowType(1)">
          <div class="dis_f ali_ct">
            <span>*</span>
            <b v-if="sendData.city">{{sendData.city}}</b>
            <b v-else>购买城市/Purchase City：</b>
          </div>
          <img class="city_icon" src="@/assets/img/throw_foot_black.png" alt>
        </div>
        <div class="diy_input dis_f ali_ct">
          <span>*</span>
          <b>姓名/Name：</b>
          <input
            name="realName"
            data-vv-as="姓名"
            v-model="sendData.realName"
            type="text"
            placeholder="请填写姓名"
            ref="nameInput"
            class="wd"
          >
        </div>
        <div class="diy_input dis_f ali_ct">
          <span>*</span>
          <b>手机/Phone：</b>
          <input
            name="phone"
            data-vv-as="手机号码"
            v-model="sendData.phone"
            v-validate="'required|digits:11|phone'"
            type="text"
            placeholder="请填写手机号"
            ref="phoneInput"
            class="wd"
          >
        </div>
        <div class="diy_input dis_f ali_ct">
          <b>邮箱/Email：</b>
          <input
            name="email"
            data-vv-as="邮箱"
            v-model="sendData.email"
            v-validate="'email'"
            type="text"
            placeholder="请填写邮箱"
            class="wd"
          >
        </div>
        <div class="floor_txt dis_f ali_ct">
          <span>*</span>
          <p>
            <b>小票单号</b>/Receipt Number
          </p>
          <img @click.stop="showHelp=true" src="@/assets/img/question.png" alt>
        </div>
        <div class="diy_input dis_f ali_ct">
          <input
            name="orderNum"
            data-vv-as="小票单号"
            v-model="sendData.orderNum"
            v-validate="'required|digits:8'"
            type="text"
            placeholder="请输入小票单号后8位/Last 8 digits of receipt number"
            ref="codeInput"
            class="form_code w100"
          >
        </div>
      </div>
      <input
        name="file"
        type="file"
        id="fileElem"
        @change="handleFiles($event)"
        ref="uploadFile"
        accept="image/*"
        class="dis_n"
      >
      <!-- class="dis_n" -->
      <div class="fl1"></div>
      <div class="upload_btn fle_no" data-name="上传购买凭证并提交" @click.stop="uploadBtn"></div>
      <div class="send_txt fle_no">
        *电商订单截图或线下商超购物小票均可。
        <br>提交此页即表示同意
        <span
          style="color:#0066FF;text-decoration: underline;"
          @click.stop="showAgreementFn(0)"
        >活动条款及细则</span>
      </div>
      <div class="send_txt fle_no">
        Online order screenshot or offline receipt photo then Submit.
        <br>By submitting means you accept
        <span
          style="color:#0066FF;text-decoration: underline;"
          @click.stop="showAgreementFn(1)"
        >terms & conditions.</span>
      </div>
      <!-- <van-actionsheet v-model="showCityList" :actions="cityList" @select="selectCity"/> -->
      <!-- 城市选择弹窗 -->
      <div class="bb_box dis_f fle_f" v-if="showCityList" @click.stop="changeShowType(0)">
        <div class="w100 city_box">
          <div
            class="city_list"
            @click.stop="selectCity(item.name)"
            v-for="(item,index) in cityList"
            :key="index"
          >{{item.name}}</div>
        </div>
      </div>
      <!-- 帮助弹窗 -->
      <div class="bb_box" v-if="showHelp" @click.stop="showHelp=false">
        <img src="@/assets/img/teach_img.jpg" class="help_img fle_no" alt>
      </div>
      <!-- 协议弹窗 -->
      <AgeerementBox v-model="showAgreement" :showEn="showEn"/>
    </div>
  </div>
</template>

<script>
import AgeerementBox from "@/components/Ageerement";
export default {
  components: {
    AgeerementBox
  },
  data() {
    return {
      sendData: {
        realName: "",
        phone: "",
        email: "",
        orderNum: "",
        city: ""
      },
      showCityList: false,
      showHelp: false,
      showAgreement: false,
      showEn: false,
      cityList: [
        {
          name: "网上商城E-shop"
        },
        {
          name: "北京/Beijing"
        },
        {
          name: "长沙/Changsha"
        },

        {
          name: "成都/Chengdu"
        },
        {
          name: "重庆/Chongqing"
        },
        {
          name: "大连/Dalian"
        },
        {
          name: "广州/Guangzhou"
        },
        {
          name: "贵阳/Guiyang"
        },
        {
          name: "杭州/Hangzhou"
        },
        {
          name: "合肥/Hefei"
        },
        {
          name: "济南/Jinan"
        },
        {
          name: "南京/Nanjing"
        },
        {
          name: "南宁/Nanning"
        },
        {
          name: "宁波/Ningbo"
        },
        {
          name: "青岛/Qingdao"
        },
        {
          name: "厦门/Xiamen"
        },
        {
          name: "上海/Shanghai"
        },
        {
          name: "深圳/Shenzhen"
        },
        {
          name: "沈阳/Shenyang"
        },
        {
          name: "石家庄/Shijiazhuang"
        },
        {
          name: "苏州/Suzhou"
        },
        {
          name: "太原/Taiyuan"
        },
        {
          name: "天津/Tianjin"
        },
        {
          name: "温州/Wenzhou"
        },
        {
          name: "无锡/Wuxi"
        },
        {
          name: "武汉/Wuhan"
        },
        {
          name: "西安/Xian "
        },
        {
          name: "郑州/Zhengzhou"
        },
        {
          name: "中山/Zhongshan"
        }
      ]
    };
  },
  methods: {
    selectCity(item) {
      console.log("点击选择城市按钮");
      console.log(item);
      this.sendData.city = item;
      this.showCityList = false;
    },
    showAgreementFn(type) {
      this.showAgreement = true;
      this.showEn = Boolean(type);
    },
    changeShowType(type) {
      this.showCityList = Boolean(type);
    },
    async uploadBtn() {
      try {
        if (!this.sendData.name) {
          this.$refs.nameInput.classList.add("none");
        }
        if (!this.sendData.phone) {
          this.$refs.phoneInput.classList.add("none");
        }
        if (!this.sendData.orderNum) {
          this.$refs.codeInput.classList.add("none");
        }
        const testType = await this.$validator.validateAll();
        if (testType) {
          // 判断城市
          if (!this.sendData.city) {
            this.$refs.codeInput.classList.add("none");
            this.$toast("请选择城市");
            return;
          }
          // 校验通过
          this.$refs.uploadFile.click();
        } else {
          this.$toast(this.errors.all()[0]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleFiles() {
      let files = this.$refs.uploadFile.files[0];
      var data = new FormData();
      data.append("file", files);
      var config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      };
      try {
        this.$toast({
          mask: true,
          message: "疯狂压缩中...",
          duration: 0,
          type: "loading"
        });
        const result = await this.axios.post(
          "http://wine.koyooo.com/phone/updateImg.html",
          data,
          config
        );
        if (result.code != 200) {
          return new Promise.reject();
        }
        try {
          this.$toast({
            mask: true,
            message: "疯狂上传中...",
            duration: 0,
            type: "loading"
          });
          const sendData = JSON.parse(JSON.stringify(this.sendData));
          if (!sendData.email) {
            delete sendData.email;
          }
          sendData.imageUrl = result.url;
          sendData.uid = "1";
          const sendType = await this.axios.post(
            "http://wine.koyooo.com/phone/saveUserTicket.html",
            sendData,
            {
              transformRequest: [
                function(data) {
                  // 对 data 进行任意转换处理
                  let postData = "";
                  for (let [item, val] of Object.entries(sendData)) {
                    postData += item + "=" + val + "&";
                  }
                  postData = postData.slice(0, -1);
                  return postData;
                }
              ]
            }
          );
          if (sendType.code != 200) {
            return new Promise.reject();
          }
          this.$toast.clear();
          this.$router.replace("/result");
        } catch (error) {
          this.$toast.clear();
          this.$toast("上传出错");
        }
      } catch (error) {
        this.$toast.clear();
        this.$toast("图片压缩出错");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/img/upload_bg.jpg") no-repeat center bottom;
  background-size: cover;
  .top_box {
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(255, 255, 255, 0.5);
    overflow-y: auto;
  }
  .top_txt {
    height: 57px;
    width: 131px;
    margin: 30px 0;
    margin-left: 30px;
  }
  .box_warn {
    height: 151px;
    margin: 46px 0 60px;
  }
  .form_code::placeholder {
    font-size: 24px;
    letter-spacing: -1px;
  }
  .diy_input {
    width: 636px;
    height: 85px;
    padding: 0 20px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 20px;
    border: 5px solid #f00000;
    flex-shrink: 0;
    span {
      font-size: 32px;
      color: #f00000;
      line-height: 100%;
    }
    b {
      line-height: 100%;
      font-weight: 400;
      font-size: 32px;
      color: #0d0000;
      white-space: nowrap;
    }
    input {
      height: 60px;
      flex: 1;
      font-size: 32px;
      &.none::placeholder {
        color: #f00000;
      }
      &.wd {
        width: 300px;
      }
    }
  }
  .city_icon {
    width: 25px;
  }
  .upload_btn {
    width: 559px;
    height: 112px;
    margin-bottom: 30px;
    flex-shrink: 0;
    background: url("~@/assets/img/upload_btn.png") no-repeat center bottom;
    background-size: contain;
  }
  .send_txt {
    line-height: 30px;
    color: rgba(49, 49, 49, 1);
    font-size: 22px;
    margin-bottom: 20px;
  }
  .floor_txt {
    width: 636px;
    padding-bottom: 20px;
    margin: 0 auto;
    font-size: 32px;
    span {
      color: #f00000;
    }
    img {
      width: 34px;
      margin-left: 20px;
    }
  }
}
.city_box {
  padding: 26px 56px;
  background: #fff;
  height: 800px;
  overflow-y: auto;
  .city_list {
    line-height: 70px;
    color: #0d0000;
    font-size: 32px;
    position: relative;
    &:last-of-type::before {
      border: none;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border: solid 1px #b5b5b5;
      transform: scale(1, 0.5);
    }
  }
}
.help_img {
  width: 428px;
  margin: 80px auto;
}
.bb_box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

